module.exports = __webpack_public_path__ + "static/media/avatar-child-girl.fe633ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/avatar-child-girl.png
// module id = 298
// module chunks = 0